import React, {useContext} from "react";
import preval from "preval.macro";

import Config from "config";

import styles from "editor/sidebar/heading/Heading.module.scss";
import {Context} from "context";

export default function Heading() {
    const context = useContext(Context);

    const fullScreenImageSrc = context.fullScreen ?
        require(`images/icons/enableFullScreen${context.lightTheme ? "-light" : "-dark"}.svg`):
        require(`images/icons/disableFullScreen${context.lightTheme ? "-light" : "-dark"}.svg`)
    
    return (
        <div className={styles.head}>
            <div className={`bgTertiary ${styles.buttons}`}>
                <a className={`highlightPrimary ${styles.back}`} href={Config.dashboard}>
                    <img src={require(`images/icons/back-dark.svg`)} alt="Back" />
                    <span>Back to Dashboard</span>
                </a>
                <div className={`bgTertiary highlightPrimary ${styles.fullscreen}`} onClick={context.toggleFullScreen}>
                    <span>Fullscreen</span>
                    <img
                        src={fullScreenImageSrc}
                        alt="Disable Full Screen"
                        data-hint={context.text.hints.fullScreen}
                    />
                </div>
            </div>
            <a
                className={`bgTertiary ${styles.logo}`}
                href={Config.dashboard}
                title={'Version ' + Config.version + ' at ' + preval`module.exports = new Date().toLocaleString();`}
            >
                <img src={require(`images/speedweaver${context.lightTheme ? "-light" : ""}.svg`)} alt="Speedweaver Logo"/>
            </a>
        </div>
    )
}